module.exports = __webpack_public_path__ + "static/img/11.ad95ab7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/11.png
// module id = 5XR3
// module chunks = 1